import { delayedCall, dispatcher, IEvent, ingenuity, killDelayedCall } from "@quest/base-core";
import { SlotEventConstantsBehavior, WinPresentationController } from "@quest/murka-games-behavior-panther/dist";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { Model as platformModel } from "@quest/platform-murka-phase_2/dist";
import { gameConstants } from "../Constants/gameConstants";

/**
 * WinPresentationControllerGame class handels the winpresentation for base game.
 * it controls the win frames, symbol animation presentation.
 */
export class WinPresentationControllerGame extends WinPresentationController {
  /**
   * subscribe all events
   */
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_SYM_WIN, this.onShowSymWin, this);
  }

  /**
   * unsubscribe all events
   */
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.SHOW_SYM_WIN, this.onShowSymWin, this);
  }
  /**
   * overrided to add stage click functionality in case of cascading tickup
   */
  protected onStageClicked(evt: IEvent): void {
    if (ingenuity.configData.stageClickOnCascade) {
      if ((ingenuity.parserModel as GameParserModel).getCascadingStatus()) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.FORCE_STOP_WIN_METER_TICKUP);
      } else {
        super.onStageClicked(evt);
      }
    } else {
      super.onStageClicked(evt);
    }
  }

  /**
   * This method will show Symbol animation
   */
  private onShowSymWin(evt: IEvent): void {
    this.view.addChild(this.view.getMeterById("winMtr")); // to bring winmeter on top of win frames
    if ((ingenuity.parserModel as platformModel).getHasLineWins()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_ALL_SYMBOL_ANIM);
    }
    delayedCall(
      gameConstants.NEXT_LINE_TOGGLE,
      gameConstants.DELAY_FOR_NEXT_LINE_TOGGLE_TIME,
      () => {
        killDelayedCall(gameConstants.NEXT_LINE_TOGGLE);
        const currentCascadeLineCount: number = (ingenuity.parserModel as GameParserModel).getCascadeLineToggleCount();
        (ingenuity.parserModel as GameParserModel).setCascadeLineToggleCount(currentCascadeLineCount - 1);
        dispatcher.fireEvent(eventDispatchers.START_NEXT_LINE_TOGGLE);
      },
      this
    );
  }
}
